export default {
	'dashboard.IntroduceRow.totalSales': 'Tổng Doanh Thu',
	'dashboard.IntroduceRow.indicatorExplain': 'Giải thích chỉ số',
	'dashboard.IntroduceRow.daySales': 'Doanh thu ngày',
	'dashboard.IntroduceRow.weekCompare': 'So sánh tuần',
	'dashboard.IntroduceRow.dayCompare': 'So sánh ngày',
	'dashboard.IntroduceRow.visits': 'Số IP truy cập',
	'dashboard.IntroduceRow.dayVisits': 'Số IP truy cập trong ngày',
	'dashboard.IntroduceRow.paymentCount': 'Tỷ lệ verify Telegram',
	'dashboard.IntroduceRow.conversionRate': 'Tỷ lệ chuyển đổi',
	'dashboard.IntroduceRow.operationEffect': 'Hiệu quả hoạt động',
	// Months in Vietnamese
	'dashboard.months.1': 'Tháng 1',
	'dashboard.months.2': 'Tháng 2',
	'dashboard.months.3': 'Tháng 3',
	'dashboard.months.4': 'Tháng 4',
	'dashboard.months.5': 'Tháng 5',
	'dashboard.months.6': 'Tháng 6',
	'dashboard.months.7': 'Tháng 7',
	'dashboard.months.8': 'Tháng 8',
	'dashboard.months.9': 'Tháng 9',
	'dashboard.months.10': 'Tháng 10',
	'dashboard.months.11': 'Tháng 11',
	'dashboard.months.12': 'Tháng 12',
	// Activity Explorer
	'activity.explorer.title': 'Trình khám phá Hoạt động',
	'activity.explorer.subTitle': 'Tra cứu toàn bộ lịch sử tương tác của người dùng trên hệ thống',
	'activity.explorer.headerTitle': 'Nhật ký hoạt động hệ thống',
	'activity.explorer.col.time': 'Thời gian',
	'activity.explorer.col.wallet': 'Địa chỉ ví',
	'activity.explorer.col.type': 'Loại',
	'activity.explorer.col.desc': 'Mô tả',
	'activity.explorer.col.status': 'Trạng thái',
	'activity.explorer.col.amount': 'Số lượng',
	'activity.explorer.col.txHash': 'Tx Hash',
	'activity.explorer.pagination.total': 'Tổng cộng {total} hoạt động',
}